import { axiosMockAdapterInstance } from "apis/index";
import { getResponseData } from "./index";

export const data = [
  {
    network: "binance-smart-chain-testnet",
    currency: "BNB",
    isMainnet: false,
    networkId: "97",
    masterOperatingWallet: "0x12c8fEbF99C65B53158644f910B565063e967B62",
    autoTopupThreshold: "0.02",
    autoTopupAmount: "0.1",
    masterOperatingWalletBalance: "0.08495327",
  },
];

export const allOW = {
  operatingWallets: [
    {
      id: "62e3a3594a3fc90007cab1ab",
      name: "Operator 1",
      index: 1,
      activeStatus: "ACTIVE",
      commandStatus: "FREE",
      createdAt: "2022-07-29T09:07:37.056Z",
      updatedAt: "2022-08-01T10:32:21.709Z",
      address: "0x7544Cbdaa11F9421F0dc00261c9f58B24850408C",
    },
    {
      id: "62e3a3594a3fc90007cab1ac",
      name: "Operator 2",
      index: 2,
      activeStatus: "ACTIVE",
      commandStatus: "FREE",
      createdAt: "2022-07-29T09:07:37.057Z",
      updatedAt: "2022-08-02T02:41:56.815Z",
      address: "0x579b81D89483d96a03EB533116d059be517e7291",
    },
    {
      id: "62e3a3594a3fc90007cab1ad",
      name: "Operator 3",
      index: 3,
      activeStatus: "ACTIVE",
      commandStatus: "FREE",
      createdAt: "2022-07-29T09:07:37.058Z",
      updatedAt: "2022-08-01T10:34:04.283Z",
      address: "0xD412D888FE8362c88F46e3fA68AE3357dFCdB0cd",
    },
    {
      id: "62e3a3594a3fc90007cab1ae",
      name: "Operator 4",
      index: 4,
      activeStatus: "ACTIVE",
      commandStatus: "FREE",
      createdAt: "2022-07-29T09:07:37.058Z",
      updatedAt: "2022-08-01T10:59:25.545Z",
      address: "0xE76734b7A7F292307Ef2b784EC18127fbbBCA10c",
    },
    {
      id: "62e3a3594a3fc90007cab1af",
      name: "Operator 5",
      index: 5,
      activeStatus: "ACTIVE",
      commandStatus: "FREE",
      createdAt: "2022-07-29T09:07:37.058Z",
      updatedAt: "2022-08-01T11:02:42.428Z",
      address: "0xa5D93D3Fb38f2681aD8C9B8D7F53D06FbA4e976e",
    },
    {
      id: "62e3a3594a3fc90007cab1b0",
      name: "Operator 6",
      index: 6,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.059Z",
      updatedAt: "2022-07-29T09:07:37.059Z",
      address: "0xfFdD1bcD9Fe2b24DDf1D1584e4793479dE55B7d6",
    },
    {
      id: "62e3a3594a3fc90007cab1b1",
      name: "Operator 7",
      index: 7,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.059Z",
      updatedAt: "2022-07-29T09:07:37.059Z",
      address: "0xa8e30f8cFaD33Fc1adA7D69C2BB633D441Ee5Cb1",
    },
    {
      id: "62e3a3594a3fc90007cab1b2",
      name: "Operator 8",
      index: 8,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.060Z",
      updatedAt: "2022-07-29T09:07:37.060Z",
      address: "0x0a06cba44dEEC3848a9Fe186B7336C0e09A157C5",
    },
    {
      id: "62e3a3594a3fc90007cab1b3",
      name: "Operator 9",
      index: 9,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.060Z",
      updatedAt: "2022-07-29T09:07:37.060Z",
      address: "0x089417847cbB35A21999cF39c903a5266f072B4E",
    },
    {
      id: "62e3a3594a3fc90007cab1b4",
      name: "Operator 10",
      index: 10,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.061Z",
      updatedAt: "2022-07-29T09:07:37.061Z",
      address: "0x2cf7BE407Cfa79cF7b4Cd3f623216a517e85169a",
    },
    {
      id: "62e3a3594a3fc90007cab1b5",
      name: "Operator 11",
      index: 11,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.061Z",
      updatedAt: "2022-07-29T09:07:37.061Z",
      address: "0xc2824200f04a4225e69009AEb0dE5EF2546C62Ab",
    },
    {
      id: "62e3a3594a3fc90007cab1b6",
      name: "Operator 12",
      index: 12,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.061Z",
      updatedAt: "2022-07-29T09:07:37.061Z",
      address: "0xfb0d9E45E057B392A2151483c1344ffA2Dd35266",
    },
    {
      id: "62e3a3594a3fc90007cab1b7",
      name: "Operator 13",
      index: 13,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.063Z",
      updatedAt: "2022-07-29T09:07:37.063Z",
      address: "0x32F1AB34302cE79069eCa2Cef2239eFe259a42C6",
    },
    {
      id: "62e3a3594a3fc90007cab1b8",
      name: "Operator 14",
      index: 14,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.064Z",
      updatedAt: "2022-07-29T09:07:37.064Z",
      address: "0x63380B546145703b02038FC6192b3BEC03651Bd9",
    },
    {
      id: "62e3a3594a3fc90007cab1b9",
      name: "Operator 15",
      index: 15,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.064Z",
      updatedAt: "2022-07-29T09:07:37.064Z",
      address: "0x221C6608edaE1eb9dd6b7a4A70E72bc6E87dB318",
    },
    {
      id: "62e3a3594a3fc90007cab1ba",
      name: "Operator 16",
      index: 16,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.066Z",
      updatedAt: "2022-07-29T09:07:37.066Z",
      address: "0xAAB8c323a3aFDfCF07F91039330BDBD68ae8960d",
    },
    {
      id: "62e3a3594a3fc90007cab1bb",
      name: "Operator 17",
      index: 17,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.066Z",
      updatedAt: "2022-07-29T09:07:37.066Z",
      address: "0x5fA3121101582820Fd4fF6BEC7Fa0185DEcE4D47",
    },
    {
      id: "62e3a3594a3fc90007cab1bc",
      name: "Operator 18",
      index: 18,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.066Z",
      updatedAt: "2022-07-29T09:07:37.066Z",
      address: "0x99F13bf7341788A7E8e7d7CFb6A1f73545346405",
    },
    {
      id: "62e3a3594a3fc90007cab1bd",
      name: "Operator 19",
      index: 19,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.066Z",
      updatedAt: "2022-07-29T09:07:37.066Z",
      address: "0x8c4d3Fea65F85088fdb839D5c027d116408C661E",
    },
    {
      id: "62e3a3594a3fc90007cab1be",
      name: "Operator 20",
      index: 20,
      activeStatus: "INACTIVE",
      commandStatus: "NONE",
      createdAt: "2022-07-29T09:07:37.067Z",
      updatedAt: "2022-07-29T09:07:37.067Z",
      address: "0xB20521C6FfC25e2D635B663172191a3Ecda1589E",
    },
  ],
  networks: [
    {
      bip44Path: "m/44'/60'/0'/0",
      currency: "BNB",
      isMainnet: false,
      provider: "https://nd-847-411-493.p2pify.com/24c3f501a9c544c6a477ec1d57f482e0",
      wssProvider: "wss://ws-nd-847-411-493.p2pify.com/24c3f501a9c544c6a477ec1d57f482e0",
      network: "binance-smart-chain-testnet",
      fpMasterContract: "0x0348c96506Aa027E781Cf91E9d499F8C801D3C9C",
      transactionUrl: "https://testnet.bscscan.com/tx/",
      fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
      networkId: "97",
      cmcId: 1839,
      decimal: 18,
    },
  ],
};

export const onGetOWSettings = () => {
  axiosMockAdapterInstance.onGet("/operating-wallets/settings").reply(() => {
    return [200, getResponseData(data, data.length)];
  });
};

export const onGetAllOW = () => {
  axiosMockAdapterInstance.onGet("/operating-wallets").reply(() => {
    return [200, getResponseData(allOW, allOW.operatingWallets.length)];
  });
};
